module.exports = __webpack_public_path__ + "img/booking-opened.fe7d17dc.svg";